Ext.define('ViewFirmas', {
    extend: 'Ext.panel.Panel',
    grid: null,
    gridpage: null,
    windowObject: null,
    id: "firmas",
    taskContextMenu: null,
    plynList: null,
    rowContext: null,
    rebuildGrid: false,
    showState: false,
    // showOnly: false,
    statics: {
        accessPropertyName: "access.manage.firmy",
        accessPropertyViewName: "access.view.firmy"
    },
    cat: "k",
    text: Lang.firmy,
    buttonIconCls: "iconFirma",
    layout: 'border',
    frame: false,
    border: false,
    initComponent: function () {
        this.buttonId = "main-view-button-" + this.id;
        this.buildGrid();
        this.items = [{
            region: "north",
            xtype: 'toolbar',
            items: [{
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconNew",
                text: Lang.nowy.capitalise(),
                scope: this,
                handler: this.dodajObiekt,
                disabled: !validPrivilegesOperatorComplex(ViewFirmas.accessPropertyName + "/add")
            }, {
                id: this.id + "bedit",
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconEdit",
                scope: this,
                text: Lang.edytuj.capitalise(),
                handler: this.edytujObiekt,
                disabled: !validPrivilegesOperatorComplex(ViewFirmas.accessPropertyName + "/update")
            }, {
                id: this.id + "bdelete",
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconDelete",
                scope: this,
                text: Lang.usun.capitalise(),
                handler: this.usunObiekt,
                disabled: !validPrivilegesOperatorComplex(ViewFirmas.accessPropertyName + "/delete")
            }, "-", {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconPDF",
                text: Lang.pdf.capitalise(),
                scope: this,
                handler: this.getDownloadLsPdf
            }, {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconEXCEL",
                text: Lang.excel.capitalise(),
                scope: this,
                handler: this.getDownloadLsExcel
            }, "-", {
                xtype: 'button',
                iconAlign: 'left',
                iconCls: "iconRefresh",
                text: Lang.odswiez.capitalise(),
                scope: this,
                handler: this.refreshDatastore
            }, {
                xtype: "checkbox",
                id: this.id + "showonlysupported",
                boxLabel: Lang.pokazuj_tylko_obslugiwane,
                stateId: "showonlysupported-" + this.id + (AppFIRMACTX == null ? "-all" : "-"),
                stateful: true,
                stateEvents: ["change"],
                hidden: Const.BASICFLAG || Const.STANDARDFLAG || Const.OPTIMALFLAG || Const.STARTERFLAG,
                getState: function () {
                    return {
                        value: this.getValue()
                    };
                },
                applyState: function (state) {
                    if (state) {
                        this.setValue(state.value);
                    }
                },
                listeners: {
                    scope: this,
                    change: this.refreshDatastore
                }
            }, {
                xtype: "box",
                id: this.id + "kontekstfirmybox",
                cls: "kontekstfirmy-box"
            }, {
                id: this.id + "kontekstfirmy",
                xtype: 'label',
                style: 'display:block;margin-right:5px',
                cls: "kontekstfirmy-text"
            }]
        }, {
            region: "center",
            xtype: 'panel',
            frame: false,
            border: false,
            layout: 'fit',
            items: [this.grid]
        }];
        this.callParent(arguments);
    },
    showFirst: function (eventMain) {
        eventMain.on("firmaChangeContext", this.changeContext, this);
    },
    remove: function () {
        this.callParent(arguments);
    },
    show: function () {
        this.showState = true;
        this.callParent(arguments);
        this.changeContextRebuild(null, null);
    },
    extractIdAndName: function (data) {
        var plynArray = [];
        for (var i = 0; i < data.length; i++) {
            var plyn = {
                id: data[i].id,
                nazwa: data[i].nazwa
            };
            plynArray.push(plyn);
        }
        return plynArray;
    },
    hide: function () {
        this.showState = false;
        this.callParent(arguments);
    },
    onDestroy: function () {
        this.taskContextMenu.destroy();
        this.callParent(arguments);
    },
    changeContextRebuild: function (eAppFIRMACTX, eAppFIRMACTXold) {
        var kontekstfirmy = Ext.getCmp(this.id + "kontekstfirmy");
        var kontekstfirmybox = Ext.getCmp(this.id + "kontekstfirmybox");
        if (AppFIRMACTX != null && !Const.AGGREGATEDCORE) {
            kontekstfirmybox.update("<div class='appSetColourRedSplit'></div>");
            kontekstfirmy.setText(Lang.pracujesz_w_kontekscie + AppFIRMACTX.nazwa);
        } else {
            kontekstfirmybox.update("");
            kontekstfirmy.setText("");
        }
        sendAjaxDataJsonRpcL("rest/plyny/getList", null, this, function (data) {
            if (data.status) {
                var newPlynList = this.extractIdAndName(data.data);
                if (Ext.JSON.encode(this.plynList) != Ext.JSON.encode(newPlynList)) {
                    this.plynList = newPlynList;
                    this.rebuildGrid = true;
                }
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
            if (this.rebuildGrid) {
                this.rebuildGrid = false;
                var onwer = this.grid.ownerCt;
                Ext.suspendLayouts();
                onwer.remove(this.grid);
                this.grid.destroy();
                this.taskContextMenu.destroy();
                this.buildGrid();
                onwer.add(this.grid);
                Ext.resumeLayouts(true);
            }
            this.refreshDatastore();
        });
    },
    changeContext: function (eAppFIRMACTX, eAppFIRMACTXold) {
        this.rebuildGrid = true;
        if (this.showState) {
            this.changeContextRebuild(null, null);
            this.refreshDatastore();
        }
        this.manageSelect();
    },
    scrollToView: function (id) {
        this.grid.selectRowScroll("id", this.id);
    },
    buildGrid: function () {
        var columnsArray = [{
            header: "ID",
            width: 145,
            sortable: true,
            dataIndex: 'id',
            filter: {
                type: 'numeric'
            },
            filterable: true,
            hidden: true
        }, {
            header: Lang.nazwa,
            flex: 2,
            sortable: true,
            dataIndex: 'nazwa',
            filter: {
                type: 'string'
            },
            sorter: Ext.bind(customSorterForGrid, this, ["nazwa"], true),
            filterable: true
        }, {
            header: Lang.opis,
            flex: 2,
            sortable: true,
            dataIndex: 'opis',
            filter: {
                type: 'string'
            },
            sorter: Ext.bind(customSorterForGrid, this, ["opis"], true),
            filterable: true
        }];
        var recordType = [{
            name: 'id',
            mapping: 'id'
        }, {
            name: 'nazwa',
            mapping: 'nazwa'
        }, {
            name: 'opis',
            mapping: 'opis'
        }];
        if (this.plynList != null) {
            for (var i = 0; i < this.plynList.length; i++) {
                var plyn = this.plynList[i];
                columnsArray.push({
                    header: Lang.pozostaly_przydzial + " [ " + plyn.nazwa + " ]",
                    flex: 2,
                    sortable: true,
                    filter: {
                        type: 'numeric'
                    },
                    filterable: true,
                    dataIndex: "plyn_" + plyn.id
                });
                recordType.push({
                    name: "plyn_" + plyn.id,
                    mapping: "plyn_" + plyn.id
                });
            }
        }
        this.grid = new Ext.ux.grid.GridPanelExd({
            plugins: {
                gridfilters: true
            },
            store: new Ext.data.Store({
                proxy: new Ext.data.MemoryProxy(),
                autoLoad: false,
                model: Ext.define(null, {
                    extend: 'Ext.data.Model',
                    idProperty: 'id',
                    fields: recordType
                }),
                reader: new Ext.data.ArrayReader()
            }),
            columns: columnsArray,
            frame: false,
            border: false,
            stateId: "this.grid-" + this.id,
            stateful: true,
            stripeRows: true,
            enableHdMenu: true,
            selModel: {
                selType: 'rowmodel',
                mode: 'single',
                allowDeselect: false
            }
        });
        this.grid.addListener("rowdblclick", function () {
            if (validPrivilegesOperatorComplex(ViewFirmas.accessPropertyName + "/update"))
                this.edytujObiekt();
        }, this);
        this.grid.addListener("render", function () {
            this.manageSelect(this.grid.getSelectionModel());
        }, this);
        this.grid.addListener("select", function (selectionModel, record, index) {
            this.manageSelect(selectionModel);
        }, this);
        this.grid.addListener("selectionchange", function (selectionModel, record, index) {
            this.manageSelect(selectionModel);
        }, this);
        this.taskContextMenu = new Ext.menu.Menu();
        this.taskContextMenu.add([{
            iconAlign: 'left',
            iconCls: "iconNew",
            text: Lang.nowy.capitalise(),
            scope: this,
            handler: this.dodajObiekt,
            disabled: !validPrivilegesOperatorComplex(ViewFirmas.accessPropertyName + "/add")
        }, {
            id: this.id + "bedit2",
            iconAlign: 'left',
            iconCls: "iconEdit",
            text: Lang.edytuj.capitalise(),
            scope: this,
            handler: this.edytujObiekt,
            disabled: !validPrivilegesOperatorComplex(ViewFirmas.accessPropertyName + "/update")
        }, {
            id: this.id + "bdelete2",
            iconAlign: 'left',
            iconCls: "iconDelete",
            text: Lang.usun.capitalise(),
            scope: this,
            handler: this.usunObiekt,
            disabled: !validPrivilegesOperatorComplex(ViewFirmas.accessPropertyName + "/delete")
        }, "-", {
            iconAlign: 'left',
            iconCls: "iconPDF",
            text: Lang.pdf.capitalise(),
            scope: this,
            handler: this.getDownloadLsPdf
        }, {
            iconAlign: 'left',
            iconCls: "iconEXCEL",
            text: Lang.excel.capitalise(),
            scope: this,
            handler: this.getDownloadLsExcel
        }, "-", {
            iconAlign: 'left',
            iconCls: "iconRefresh",
            text: Lang.odswiez.capitalise(),
            scope: this,
            handler: this.refreshDatastore
        }
        ]);
        this.grid.addListener("rowcontextmenu", function (grid, record, tr, rowIndex, e) {
            this.rowContext = this.grid.getStore().getAt(rowIndex);
            this.manageSelect();
            this.taskContextMenu.showAt(e.getXY());
            e.preventDefault();
        }, this);
        this.taskContextMenu.addListener("hide", function () {
            this.rowContext = null;
        }, this);
        this.grid.addListener("containercontextmenu", function (grid, e) {
            this.rowContext = null;
            this.manageSelect();
            this.taskContextMenu.showAt(e.getXY());
            e.preventDefault();
        }, this);
    },
    manageSelect: function () {
        if (this.showState) {
            var bedit = Ext.getCmp(this.id + "bedit");
            var bdelete = Ext.getCmp(this.id + "bdelete");
            var bedit2 = Ext.getCmp(this.id + "bedit2");
            var bdelete2 = Ext.getCmp(this.id + "bdelete2");
            if (!this.grid.getSelectionModel().hasSelection() || this.grid.getSelectionModel().getSelection() == null || this.grid.getSelectionModel().getSelection().length == 0) {
                bdelete.setDisabled(true);
                bedit.setDisabled(true);
            } else {
                var row = this.grid.getSelectionModel().getSelection()[0];
                bdelete.setDisabled(!validPrivilegesOperatorComplex(ViewFirmas.accessPropertyName + "/delete"));
                bedit.setDisabled(!validPrivilegesOperatorComplex(ViewFirmas.accessPropertyName + "/update"));
            }
            if (this.rowContext == null) {
                bdelete2.setDisabled(true);
                bedit2.setDisabled(true);
            } else {
                bdelete2.setDisabled(!validPrivilegesOperatorComplex(ViewFirmas.accessPropertyName + "/delete"));
                bedit2.setDisabled(!validPrivilegesOperatorComplex(ViewFirmas.accessPropertyName + "/update"));
            }
        }
    },
    getDownloadLsPdf: function () {
        postFormAsync("rest/pdfexcelexport/downloadExport", {
            format: "pdf",
            name: Lang.firmy,
            defd: Ext.encode(this.grid.getDefGridDataCSF({
                colsEx: [],
                colsIn: [],
                useRenderer: true,
                fnd: function (v, c, metaData, record, rowIndex, colIndex, store) {
                    return v;
                }
            }))
        }, null);
    },
    getDownloadLsExcel: function () {
        postFormAsync("rest/pdfexcelexport/downloadExport", {
            format: "excel",
            name: Lang.firmy,
            defd: Ext.encode(this.grid.getDefGridDataCSF({
                colsEx: [],
                colsIn: [],
                useRenderer: true,
                fnd: function (v, c, metaData, record, rowIndex, colIndex, store) {
                    return v;
                }
            }))
        }, null);
    },
    refreshDatastore: function () {
        updateCzasRefreshSerwer();
        var showOnlySupportedParam = Ext.getCmp(this.id + "showonlysupported").getValue();
        if (this.grid && this.grid.rendered)
            this.grid.mask();
        sendAjaxDataJsonRpcL("rest/firmy/getListWithPlynState", {showOnlySupported: showOnlySupportedParam}, this, function (data) {
            if (this.grid && this.grid.rendered)
                this.grid.unmask();
            if (data.status) {
                this.grid.store.loadData(data.data);
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
        });
    },
    refreshDatastoreAfterEdit: function () {
        updateCzasRefreshSerwer();
        var showOnlySupportedParam = Ext.getCmp(this.id + "showonlysupported").getValue();
        if (this.grid && this.grid.rendered)
            this.grid.mask();
        sendAjaxDataJsonRpcL("rest/firmy/getListWithPlynState", {showOnlySupported: showOnlySupportedParam}, this, function (data) {
            if (this.grid && this.grid.rendered)
                this.grid.unmask();
            if (data.status) {
                this.grid.store.loadData(data.data);
                updateFirmaListContext();
            } else {
                Ext.MessageBox.alert(Lang.error, data.error);
            }
        });
    },
    dodajObiekt: function () {
        windowObject = Ext.create('WindowFirma', {
            callbackF: Ext.Function.bind(this.refreshDatastoreAfterEdit, this)
        });
        windowObject.showW(0);
    },
    edytujObiekt: function () {
        var id = 0;
        if (!this.grid.getSelectionModel().hasSelection() && this.rowContext == null) {
            Ext.MessageBox.alert(Lang.error, Lang.prosze_wybrac_obiekt);
            return;
        } else {
            if (this.rowContext != null) {
                id = this.rowContext.id;
            } else if (this.grid.getSelectionModel().getSelection() != null && this.grid.getSelectionModel().getSelection().length > 0) {
                id = this.grid.getSelectionModel().getSelection()[0].id;
            }
        }
        windowObject = Ext.create('WindowFirma', {
            callbackF: Ext.Function.bind(this.refreshDatastoreAfterEdit, this)
        });
        windowObject.showW(id);
    },
    usunObiekt: function () {
        var id = 0;
        if (!this.grid.getSelectionModel().hasSelection() && this.rowContext == null) {
            Ext.MessageBox.alert(Lang.error, Lang.prosze_wybrac_obiekt);
            return;
        } else {
            if (this.rowContext != null) {
                id = rowContext.id;
            } else if (this.grid.getSelectionModel().getSelection() != null && this.grid.getSelectionModel().getSelection().length > 0) {
                id = this.grid.getSelectionModel().getSelection()[0].id;
            }
        }
        Ext.MessageBox.show({
            title: Lang.usuwanie,
            message: Lang.czy_napewno_usunac_obiekt,
            buttons: Ext.MessageBox.YESNO,
            scope: this,
            fn: function (btn) {
                if (btn == "yes") {
                    sendAjaxDataJsonRpcL("rest/firmy/deleteObject", {
                        id: id
                    }, this, function (data) {
                        if (data.status) {
                        } else {
                            Ext.MessageBox.alert(Lang.error, data.error);
                        }
                        this.refreshDatastoreAfterEdit();
                    });
                }
            }
        });
    }
});
